import { type PACERDocketResult } from '../../types';
import { ResultsGrid, type ViewType } from '../shared';

import { CasesResultCard } from './CasesResultCard';

export interface CasesResultsProps {
  results: PACERDocketResult[];
  viewType?: ViewType;
}

export const CasesResults = ({
  results,
  viewType = 'grid',
}: CasesResultsProps) => (
  <ResultsGrid
    results={results}
    viewType={viewType}
    renderCard={(docketItem) => <CasesResultCard docketItem={docketItem} />}
    getKey={(docketItem, index) => docketItem.docket_id || index}
  />
);
